import { prepareDataForDropdown } from '../../../../../components/organisms/Filters/utils';
import { Field_Keys } from '../../../../../constants';
import useFetchData from '../../../../../hooks/fetchHook';
import { DC } from '../controllers/variables';

export const useGetFilters = ({ ignore }) => {
  const [{ data, isLoading = true, isError, error }, _, refetchFilters] =
    useFetchData('office_reviews/filters', {
      formatter,
      ignore,
    });

  return {
    data,
    isLoading,
    isError,
    error,
    refetchFilters,
  };
};

export const formatter = data => {
  const { statuses, risk_types } = data;

  const newOps = {};

  newOps[DC.REVIEW_STATUS] = prepareDataForDropdown(
    statuses,
    Field_Keys.PARCEL.REVIEW,
    Field_Keys.PARCEL.REVIEW
  );

  newOps[DC.RISK_TYPE] = prepareDataForDropdown(
    risk_types,
    Field_Keys.PARCEL.RISK_TYPE,
    Field_Keys.PARCEL.RISK_TYPE
  );

  return newOps;
};
